module.exports = __webpack_public_path__ + "static/media/monitor.69449dbc.svg";